import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import { type LanTypes, getLanguageCode } from "@src/helpers";

export const KEY = "expectedturnovertypes";

interface Turnover {
  expectedTurnoverCode: string;
  expectedTurnover: string;
}

const getTurnovers = async (language: LanTypes) => {
  const languageCode = getLanguageCode(language);

  const response = await axiosInstance.get<{ types: Turnover[] }>(
    `/api/customer/expectedturnovertypes`,
    {
      headers: { langcode: languageCode },
    },
  );
  return response.data;
};

export const useTurnovers = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  return useQuery({
    queryKey: [KEY, i18n.language],
    queryFn: () => getTurnovers(i18n.language as LanTypes),
    onError() {
      navigate(`/${i18n.language}/error`);
    },
    staleTime: Infinity,
  });
};
